import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { placeSetSchema } from '../schemas/place-set.schema';

/**
 * Requests the Speed Coaching Profiles associated with a specific vehicle
 * @param vehicleId The vehicle ID for the vehicle whose Speed Coaching Profiles are being requested
 * @returns The Speed Coaching Profiles
 */
export function getSpeedCoachingVehiclesId(this: unknown, vehicleId: number) {
  const requestUrl = `${
    fleetEnvironment.resolve(this).speedCoachingVehiclesUrl
  }/${vehicleId}`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(placeSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
